module.exports = __webpack_public_path__ + "static/media/ls.693e16a8.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/ls.svg
// module id = 2143
// module chunks = 0